var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "search-add-from-library-parent"
    }
  }, [_c('v-header', {
    attrs: {
      "modal-button": true
    },
    on: {
      "close-modal": _vm.cancelSearchAdd
    },
    scopedSlots: _vm._u([{
      key: "modal-title",
      fn: function () {
        return [_vm._v(" " + _vm._s(_vm.emittedTitle) + " ")];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('v-stepper', {
    key: _vm.stepperKey,
    staticClass: "search-add-stepper",
    attrs: {
      "labels": _vm.stepperLabels,
      "current-step": _vm.currentStep,
      "unique-id": "search-add-from-library-parent",
      "hide-not-visited": true
    },
    on: {
      "step-changed": _vm.handleStepChanged
    }
  }), _vm._v(" "), _vm.currentStep === 1 ? _c('SearchAddFromLibrary', {
    attrs: {
      "material-type-label": _vm.materialTypeLabel,
      "group-nid": _vm.groupNid,
      "material-type": _vm.materialType
    },
    on: {
      "cancel-search-add": _vm.cancelSearchAdd,
      "change-title": _vm.changeTitle,
      "material-added": _vm.materialAddedCallback,
      "back": _vm.handleBack
    }
  }) : _vm._e(), _vm._v(" "), _vm.currentStep === 2 && _vm.selectedMaterialUuid ? _c('BioMaterialStepChooser', {
    attrs: {
      "group-nid": _vm.groupNid,
      "material-type": _vm.materialType,
      "uuid": _vm.selectedMaterialUuid
    },
    on: {
      "bio-material-step-chooser-selection": function ($event) {
        return _vm.handleStepChooserSelection($event);
      },
      "choose-modification": _vm.chooseModification,
      "change-title": _vm.changeTitle
    }
  }) : _vm._e(), _vm._v(" "), _vm.currentStep === 3 && _vm.selectedMaterialUuid ? _c('BioMaterialStepModify', {
    key: _vm.currentStep,
    attrs: {
      "group-nid": _vm.groupNid,
      "material-type": _vm.materialType,
      "uuid": _vm.selectedMaterialUuid
    },
    on: {
      "choose-modification": _vm.chooseModification,
      "emit-step-change": _vm.handleStepChanged,
      "emit-close-modal": _vm.cancelSearchAdd,
      "handle-form-data": _vm.handleModifyFormData,
      "change-title": _vm.changeTitle
    }
  }) : _vm._e(), _vm._v(" "), _vm.currentStep === 4 && _vm.selectedMaterialUuid ? _c('BioMaterialStepSummary', {
    attrs: {
      "material-label": _vm.modifiedMaterialLabel,
      "group-nid": _vm.groupNid,
      "material-removed": _vm.materialRemoved,
      "success-status": _vm.successStatus
    },
    on: {
      "summary-status": _vm.handleSummaryStatus,
      "change-title": _vm.changeTitle
    }
  }) : _vm._e(), _vm._v(" "), _vm.showEmptyState ? _c('VEmptyState', {
    attrs: {
      "title": _vm.emptyStateTitle,
      "description": _vm.emptyStateDescription,
      "use-without-v-html": true
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }